<template>
	<v-row class="container-ticket">
		<v-col cols="8">
			<v-row>
				<v-col cols="6">
					<v-container>
						<v-row>
							<h3 class="color-1">{{ configuration.ticketType.name }}</h3>
						</v-row>
						<v-row v-if="configuration.ticketType.net == 0" class="pt-2">
							<h4 class="font-weight-medium color-2">{{ $t('selectortickettype.gratuita') }}</h4>
						</v-row>
                        <v-row v-else class="pt-2">
							<h4 class="font-weight-medium color-2">{{ ticketTotal }}</h4>
							<p v-if="configuration.ticketType.priceStrikeThrough > 0" class="text-caption color-3 pl-2 pt-1"><strike> {{ ticketStrikedTotal }} </strike> </p>
						</v-row>

						<v-row no-gutters>
							<v-chip
								class="font-weight-medium"
								color="primary"
								v-if="configuration.ticketType.discountBuy && configuration.ticketType.discountPay"
							>
								{{ $t('selectortickettype.promotion') }}
								{{ `${configuration.ticketType.discountBuy} x ${configuration.ticketType.discountPay}` }}
							</v-chip>
							<promotional-code class="promotional-code-parent" style="display: block;" v-if="configuration.existPromotions" @validatePromocode="handlePromocodeValidation" />						</v-row>
					</v-container>
				</v-col>
				<v-col cols="6">
					<v-container>
						<v-row class="color-1"> {{ getStartAndEndDate(configuration.ticketType) }}</v-row>
						<v-row class="text-caption color-3">
							 {{ configuration.ticketType.details }}
						</v-row>
						<!-- <v-row class="primary--text font-weight-medium"> {{ $t('selectortickettype.moreinformation') }} </v-row> -->
					</v-container>
				</v-col>
			</v-row>
		</v-col>

		<v-col cols="4">
			<selector-number
				v-model="computedNumberOfTickets"
				:min="minTicketsToSale(configuration.ticketType)"
				:max="maxTicketsToSale(configuration.ticketType)"
				:disabled="isSelectorDisabled"
				@value-changed="calculateTicketsPriceWithPromocode"
			/>
		</v-col>
	</v-row>
</template>

<script>
import dateTimeUtils from '../../../utils/dateTimeUtils';
import numberUtils from '../../../utils/numberUtils.js';
import SelectorNumber from './SelectorNumber.vue';
import { mapActions } from 'vuex';
import PromotionalCode from './PromotionalCode.vue';

export default {
	components: {
		'selector-number': SelectorNumber,
		'promotional-code': PromotionalCode
	},
	props: {
		configuration: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		numberOfTickets: 0,
		isSelectorDisabled: false,
		promocode: ''
	}),
	computed: {
		computedNumberOfTickets: {
			get() {
				return this.numberOfTickets;
			},
			set(newValue) {
				this.numberOfTickets = newValue;
				this.calculateTicketsPrice();
			}
		},
		ticketNet() {
			return this.formatEuroNumber(this.configuration.ticketType.net);
		},
		ticketVat() {
			return this.formatEuroNumber(this.configuration.ticketType.vatValue);
		},
        ticketTotal() {
            return this.formatEuroNumber(this.configuration.ticketType.price);
        },
        ticketStrikedTotal() {
            return this.formatEuroNumber(this.configuration.ticketType.priceStrikeThrough);
        }
	},
	methods: {
		...mapActions(['CALCULATE_TICKETS_PRICE']),
		formatEuroNumber(number = 0) {
			return numberUtils.formatEuroNumber(number);
		},

		minTicketsToSale(ticketType) {
			return ticketType.availableTickets < ticketType.ticketsPerSaleMin ? 0 : ticketType.ticketsPerSaleMin;
		},

		maxTicketsToSale(ticketType) {
			return ticketType.availableTickets < ticketType.ticketsPerSale ? ticketType.availableTickets : ticketType.ticketsPerSale;
		},

		getStartAndEndDate(ticketType) {
			const start = dateTimeUtils.formatDate(ticketType.start, 'DD/MM/YYYY');
			const end = dateTimeUtils.formatDate(ticketType.end, 'DD/MM/YYYY');
			return `${start} al ${end}`;
		},

		calculateTicketsPrice() {
			const ticketTypeId = this.configuration.ticketType.id;
			const ticketId = this.configuration.id;
			const action = "button";
			this.isSelectorDisabled = true;
			const params = {
				numTickets: this.numberOfTickets,
				ticketbatchid: ticketTypeId
			};
			return this.CALCULATE_TICKETS_PRICE({ params, ticketTypeId, ticketId, action }).finally(() => {
				this.isSelectorDisabled = false;
			});
		},
		calculateTicketsPriceWithPromocode(promocode) {
			if (!this.promocode) return;
			const ticketTypeId = this.configuration.ticketType.id;
			const ticketId = this.configuration.id;
			const action = "normal";
			this.isSelectorDisabled = true;
			const params = {
				numTickets: this.numberOfTickets,
				ticketbatchid: ticketTypeId,
				code: this.promocode
			};
			return this.CALCULATE_TICKETS_PRICE({ params, ticketTypeId, ticketId, action }).finally(() => {
				this.isSelectorDisabled = false;
			});
		},
		handlePromocodeValidation(promocode) {
			this.promocode = promocode;
			this.calculateTicketsPriceWithPromocode();
		}
	},
	mounted() {
		this.computedNumberOfTickets = this.configuration.ticketType.availableTickets < this.configuration.ticketType.ticketsPerSaleMin ? 0 : this.configuration.ticketType.ticketsPerSaleMin;
		var containerTicket = document.getElementById("ticket-" + this.configuration.id);
		var promotionalCodeParent = containerTicket.getElementsByClassName("promotional-code-parent")[0];
		if (promotionalCodeParent)
			promotionalCodeParent.style.display = "none";
	}
};
</script>

<style>
.color-1 {
	color: #293133;
}
.color-2 {
	color: #575e60;
}
.color-3 {
	color: #868c8d;
}
</style>
